// Modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AccountModule } from './account/account.module';
import { AdminModule } from './admin/admin.module';
import { AngularFireModule } from '@angular/fire/compat/';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from '../environments/environment';

// Components
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import {MyProductsModule} from './my-products/my-products.module';
import { MyCartComponent } from './my-cart/my-cart/my-cart.component';
import {ClickOutsideDirective} from './utils/click-outside.directive';
import {MyCheckoutModule} from './my-checkout/my-checkout.module';


@NgModule({
  declarations: [
    AppComponent,
    MyCartComponent,
    PageNotFoundComponent,
    MyCartComponent,
    ClickOutsideDirective,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    HttpClientModule,
    SharedModule,
    ToastrModule.forRoot(),
    CoreModule,
    MyProductsModule,
    AccountModule,
    AdminModule,
    MyCheckoutModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
